import { render, staticRenderFns } from "./ChatterProjectForm.vue?vue&type=template&id=797edada&scoped=true"
import script from "./ChatterProjectForm.vue?vue&type=script&lang=js"
export * from "./ChatterProjectForm.vue?vue&type=script&lang=js"
import style0 from "./ChatterProjectForm.vue?vue&type=style&index=0&id=797edada&prod&lang=css"
import style1 from "./ChatterProjectForm.vue?vue&type=style&index=1&id=797edada&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797edada",
  null
  
)

export default component.exports